import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import pujaKitBox from '../../assets/images/new/pujaKitBox.jpg'
import { handleProceedRemainingPayment } from '../RazorPay/RazorPayFunction'
import { LoaderContext } from "../../AuthContext/AuthContext";
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import axios from 'axios';
import dayjs from 'dayjs';
import { UserWisePujaKitSubscriptionPlanBookingListByMonth } from '../../ApiServices/PujaSubscription/PujaSubscriptionApi';
import { color } from 'framer-motion';

const PujaOrdersDetailsPage = () => {
    const { setLoader } = useContext(LoaderContext);
    const location = useLocation()
    const navigate = useNavigate()
    const order = location?.state;
    const userID = JSON.parse(localStorage.getItem("userID"));
    const [subscriptionDetails, setSubscriptionDetails] = useState('')
    useEffect(() => {
        if (order?.PKSubPBookID !== null && order?.PKSubPBookID !== undefined && order?.PKSubPBookID !== '') {
            PujaKitSubscriptionPlanListData()
        }
    }, [])
    const PujaKitSubscriptionPlanListData = async () => {
        setLoader(true)
        try {
            const response = await UserWisePujaKitSubscriptionPlanBookingListByMonth(order?.PKSubPBookID); // Call your API with the slug
            if (response?.ResponseCode === "0") {
                setLoader(false)
                setSubscriptionDetails(response.DATA); // Access DATA directly as an object
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching temple details:", error);
        }
    }
    function formatToIndianCurrency(amount) {
        if (!amount) return "";

        const [integerPart, decimalPart] = amount.toString().split(".");

        // Format the integer part using Indian numbering system
        const formattedIntegerPart = integerPart.replace(
            // Match groups of 3 digits initially, then groups of 2 digits
            /(\d)(?=(\d\d)+\d$)/g,
            "$1,"
        );

        // Return the formatted value with the decimal part (if present)
        return decimalPart !== undefined
            ? `${formattedIntegerPart}.${decimalPart}`
            : formattedIntegerPart;
    }

    const handleProceedRemainingPujaPayment = async () => {
        // debugger;
        if (Math.round(order?.RemainingAmount) === 0) {
            alert("All the amount already paid");
            return;
        }


        // let minPayableAmount = modelRequestData.amountEntered
        //   ? modelRequestData.amountEntered
        //   : Math.round(grandTotal);

        const PlaceOrderResponse = await handleProceedRemainingPayment(Math.round(order.RemainingAmount))
        console.log('PlaceOrderResponse', PlaceOrderResponse)
        setLoader(true)
        if (PlaceOrderResponse?.status === 1) {

            axios
                .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=PujaKit`, {
                    USER_ID: userID,

                    ORDER_ID: order?.PKSubPBookID,
                    TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
                    PAYMENT_STATUS: "Completed",
                    TRANSACTION_STATUS: "Success",
                    TRANSACTION_AMT: order.RemainingAmount,
                    REMAING_AMOUNT: 0,
                    PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
                })
                .then((res) => {

                    if (res.data.ResponseMessage === "Success.") {
                        setLoader(false)
                        navigate("/puja-kit-orders");
                    } else {
                        setLoader(false)
                        alert("Order placement failed, please try again.");
                    }
                });
        } else if (PlaceOrderResponse?.status === 0) {
            setLoader(false)
            alert('Order Failed !')
        }
    };

    const handleDownloadInvoice = (PB_ID) => {
        window.open(order?.InvoicePDFURL, "_blank");

    };
    console.log('order', order)
    return (
        <>
            <div>
                <div className="top">
                    <div
                        className="pujaDetails custom-flex"
                        style={{
                            display: "flex",
                            padding: "20px",
                            alignItems: "flex-start",
                            maxHeight: "80vh", // restrict overall height
                            overflow: "hidden", // prevent container from overflowing
                        }}
                    >
                        <div
                            className="left"
                            style={{
                                position: "sticky",
                                top: "20px",
                                flexShrink: 0,

                            }}
                        >
                            <img
                                src={pujaKitBox}
                                width={100}
                                height={300}
                                style={{ objectFit: "contain" }}
                                alt="Puja-Img"

                            />
                            <p className='text-center' style={{ marginTop: "1rem", fontWeight: "700", color: "#333" }}>
                                <span style={{ color: '#a52444', fontWeight: "700" }}>Note:</span> Order will be delivered within 7 working days.
                            </p>
                        </div>

                        <div
                            className="right"
                            style={{
                                marginLeft: "20px",
                                // overflowY: "auto",
                                maxHeight: "80vh", // match the parent height
                                paddingRight: "10px",
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h2
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: "20px",
                                        textTransform: "none",
                                        margin: 0,
                                    }}
                                >
                                    {order.Title} Subscription
                                </h2>

                                {order.RemainingAmount > 0 && (
                                    <button className="careox-btn" onClick={handleProceedRemainingPujaPayment}>
                                        Proceed To Payment
                                    </button>
                                )}
                            </div>



                            <h4>
                                (₹){" "}

                                {formatToIndianCurrency(Math.round(Number(order.PujaKitPrice) - Number(order.DiscountAmount)))}
                            </h4>


                            <div className="mb-3 ">
                                <h5>Subscription Details:</h5>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: order.Description,
                                    }}
                                />
                            </div>



                            {/* <div className="button-container">
              <button
                className="btn btn-primary"
                style={{ backgroundColor: "#A52444", color: "white" }}
                onClick={handleOpenProductBookingModal}
              >
                Proceed to Book
              </button>
            </div> */}


                        </div>
                    </div>

                </div >
                <div className="container my-4">
                    <div className="row g-4">
                        {/* Puja Details */}
                        <div className="col-md-4">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h5 className="card-title text-center fw-bold">
                                        Kit Details
                                    </h5>
                                    <table className="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <td>Subscription Plan</td>
                                                <td className=" fw-bold">{order.Title}</td>
                                            </tr>
                                            <tr>
                                                <td>Booking Date</td>
                                                <td>{dayjs(order.BookingDate).format('DD/MM/YYYY')}</td>
                                            </tr>
                                            <tr>
                                                <td>Payment Mode</td>
                                                <td>
                                                    <i className="bi bi-credit-card"></i>{" "}
                                                    {order.PaymentType}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Payment Status</td>
                                                <td className="fw-bold ">
                                                    {order.PaymentStatus === "Complete"
                                                        ? "Completed"
                                                        : order.PaymentStatus}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Transaction Amount (₹)</td>
                                                <td>{formatToIndianCurrency(Math.round(order.PaidAmount))}</td>
                                            </tr>
                                            <tr>
                                                <td>Remaining Amount (₹) </td>
                                                <td>
                                                    {formatToIndianCurrency(Math.round(order.RemainingAmount)) || 0}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {/* Pandit Details */}
                        {subscriptionDetails?.length > 0 && (
                            <div className="col-md-4">
                                <div className="card shadow-sm">
                                    <div className="card-body" >
                                        <h5 className="card-title text-center fw-bold">
                                            Refill Details
                                        </h5>

                                        <ul className="list-group list-group-flush" style={{ borderTop: '1px  solid grey', height: '19em', overflow: "auto" }} >
                                            {subscriptionDetails.map((item, index) => (
                                                <li key={index} className="list-group-item">
                                                    <strong>Month:</strong> {item.MonthName} <br />
                                                    <strong>Refill Date:</strong> {item.RefillDate ? dayjs(item.RefillDate).format('DD/MM/YYYY') : ""} <br />
                                                    <strong>Status:</strong> {item.DeliveryStatus}
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        )}



                        {/* Price Details */}
                        <div className="col-md-4">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h5 className="card-title text-center fw-bold">
                                        Price Details
                                    </h5>
                                    <table className="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <td>Puja Kit Price (₹)</td>
                                                <td className="text-end">
                                                    {formatToIndianCurrency(
                                                        Math.round(
                                                            Number(order.PujaKitPrice) -
                                                            Number(order.DiscountAmount)
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                            {order.CouponCodeAmount !== 0 ? (
                                                <tr>
                                                    <td>
                                                        Coupon Amount (₹)
                                                    </td>
                                                    <td className="text-end">
                                                        {order.CouponCodeAmount}
                                                    </td>
                                                </tr>
                                            ) : order.WalletAmount !== 0 ?
                                                <tr>
                                                    <td>
                                                        Wallet Amount (₹)
                                                    </td>
                                                    <td className="text-end">
                                                        {order.WalletAmount}
                                                    </td>
                                                </tr> : ''}


                                            <tr className="fw-bold">
                                                <td>Total Amount (₹)</td>
                                                <td className="text-end">
                                                    {formatToIndianCurrency(order.GrandTotal)}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {order.PaymentStatus === "Completed" && order.InvoicePDFURL !== null && (
                                <a
                                    target="_blank"
                                    className="careox-btn mt-2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDownloadInvoice(order.InvoicePDFURL)}
                                >
                                    Download Invoice
                                </a>

                            )}


                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default PujaOrdersDetailsPage
